import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import styled, { css } from "styled-components";
import Button from '../../components/Button';
import { Dialog } from '@material-ui/core';

interface IconHeaderProps {
    color: string;
}

interface BtnInsertNewAnswerProps {
    color: string;
}

export const DialogContainer = styled(Dialog)`

    .MuiPaper-root {
        border-radius: 10px;
    }

`;

export const Content = styled(DialogContent)`
    background-color: white;   
`;

export const ContentBody = styled(Grid)`
    display: flex;
    justify-content: center;
    height: auto;
    width: auto;
    margin-top: 10px;
    margin-bottom: 10px;

    padding: 15px;
    padding-top: 0px;
    border: 1px solid #eef2f8;
    border-radius: 5px;
`;

export const ContainerItems = styled.div`
    width: 100%;
`;

export const DialogTop = styled.div`
    display: flex;
    padding-bottom: 10px;
    border-bottom: 1px solid #eef2f8;
    margin-top: 10px;
    width: 100%;
    position: relative;
`;

export const DialogTopLeft = styled.div`
    width: 85%;
    height: 100%;
    display: flex;
    text-align: left;
    align-items: center;
    justify-content: start;
    padding-bottom: 3px;
    padding-top: 3px;
    margin-left: 5px;
`;

export const DialogTopRight = styled.div`
    position: absolute;
    right: 20px;
    top: 17px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
        width: 30px;
        border: none;
        background-color: transparent;
    }
`;

export const DialogTopGoTo = styled.div`
    position: absolute;
    right: 20px;
    top: 0px;
    font-size: 11px;
    text-transform: uppercase;
    background-color: #893be9;
    color: white;
    font-weight: 500;
    padding: 5px 10px;
    border-radius: 0px 0px 5px 5px;
    border: none;

    :hover {
        opacity: 0.9;
    }
`;

export const IconHeader = styled.span<IconHeaderProps>`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 60px;
    height: 100%;
    background-color: transparent;

    div {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 45px;
        height: 45px;
        background-color: #f4f4f4;
        border-radius: 10px;

        ${props => props.color && css`
            background-color: ${props.color + "1e"} !important;
        `}

        > svg {
            width: 25px;
            height: 25px;

            ${props => props.color && css`
                color: ${props.color} !important;
            `}
        }

    }
`;

export const TitleHeader = styled.div`
    display: flex;
    justify-content: center;    
    align-items: flex-start;
    flex-direction: column;
    margin-left: 5px;

    h1 {     
        font-size: 22px;
        font-weight: 500;
        color: #060606de;
    }

    span {
        font-size: 12px;
        color: gray;
    }
`;

export const DialogFooter = styled.div`
  border-top: 1px solid #eef2f8;
  padding: 10px !important;
  width: 100%;
`;

export const DialogFooterCenter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-content: center;
    width: 100%;
`;

export const BtnInsertNewAnswer = styled(Button) <BtnInsertNewAnswerProps>`
    height: 50px;
    width: 95%;
    background-color: #f23b5c;
    color: white;
    border-radius: 5px;
    border: 0;
    font-weight: 500;

    ${props => props.color && css`
        background-color: ${props.color} !important;
    `}
`;

export const RegisterDetailContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #efefef;
    padding: 5px;
    padding-left: 25px;
    font-weight: 500;
    letter-spacing: 0.8px;
`;

export const RegisterDetailGoTo = styled.button`
    position: absolute;
    right: 20px;
    top: 0px;
    font-size: 11px;
    text-transform: uppercase;
    background-color: #893be9;
    color: white;
    font-weight: 500;
    padding: 5px 10px;
    border-radius: 0px 0px 5px 5px;
    border: none;

    :hover {
        background-color: #893be99c;
    }
`;

export const RegisterDetailTag = styled.span`
    color: gray;
    font-size: 12px;
    font-weight: 400;
    margin-right: 10px;
`;